import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Box, ColoredDot, colors, Flex, PageFooter } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IconContainer, PersonChip, Table, Tbody, Td, Th, Thead, Thr, Tr } from '../Accommodation.style'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import { formatDateForDisplay, formatTimeAMPM, getParams, handlePagination } from 'utils/helpers'
import { Pagination } from 'components/Pagination/Pagination'
import { useEffect, useState } from 'react'
import { getBedsHistory } from 'features/accommodation/accommodationSlice'
import { ISelectValue } from 'constants/globalTypes'

export const BedHistory = () => {
    const [params, setParams] = useState(getParams({ location, limit: 30 }))
    const { bedsHistory } = useSelector((state: RootState) => state.accomodation)
    const dispatch = useDispatch<AppDispatch>()

    const NoBeds = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No History Available for selected filters</TitleText>
        </Flex>
    }

    useEffect(() => {
        dispatch(getBedsHistory(params))
    }, [params])

    return <Flex column gap='1rem' >

        <Box width='100%' >
            <Flex gap='1rem' >
                <CalendarInput labelText='Date From' nomarg defaultValue={params.dateFrom ? new Date(params.dateFrom) : null} onChange={d => setParams(prev => ({ ...prev, dateFrom: d }))} maxDate={params.dateTo ? new Date(params.dateTo) : null} />
                <CalendarInput labelText='Date To' nomarg defaultValue={params.dateTo ? new Date(params.dateTo) : null} onChange={d => setParams(prev => ({ ...prev, dateTo: d }))} minDate={params.dateFrom ? new Date(params.dateFrom) : null} />
                {/* <HonestSelectInput onChange={null} options={[]} labelText='Camp' />
                <HonestSelectInput onChange={null} options={[]} labelText='Block' /> */}
                <HonestSelectInput width='200px' nomarg defaultValue={params.personType} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, personType: v.value }))} options={[{ label: 'Employee', value: 1 }, { label: 'Guest', value: 2 }]} labelText='Person Type' />
            </Flex>
        </Box>
        <Flex gap='1rem' end='true'>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.blue} />
                    <BodyText color={colors.blue} >Completed</BodyText>
                    <BodyText color={colors.blue} style={{ marginLeft: '0.5rem' }} >{bedsHistory.completedCount || '0'}</BodyText>
                </Flex>
            </Box>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.green} />
                    <BodyText color={colors.green} >Active</BodyText>
                    <BodyText color={colors.green} style={{ marginLeft: '0.5rem' }} >{bedsHistory.activeCount || '0'}</BodyText>
                </Flex>
            </Box>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.red} />
                    <BodyText color={colors.red} >Overdue</BodyText>
                    <BodyText color={colors.red} style={{ marginLeft: '0.5rem' }} >{bedsHistory.overdueCount || '0'}</BodyText>
                </Flex>
            </Box>
        </Flex>
        {bedsHistory.data.length === 0 ? <NoBeds /> : <Table>
            <Thead>
                <Thr>
                    <Th>PERSON</Th>
                    <Th>TYPE</Th>
                    <Th>BED</Th>
                    <Th>LOCATION</Th>
                    <Th>CHECK-IN</Th>
                    <Th>CHECK-OUT</Th>
                    <Th>CHECK-OVERRIDE</Th>
                </Thr>
            </Thead>
            <Tbody>
                {bedsHistory.data.map((bed) => (<Tr key={bed.id} >
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>{bed.user ? (bed.user.firstName + ' ' + bed.user.lastName) : (bed.accommodationGuest?.firstName + ' ' + bed.accommodationGuest?.lastName)}</TitleText>
                            <OtherText grey>ID: {bed.accommodationGuest ? bed.accommodationGuest?.identificationNumber : bed.user?.id}</OtherText>
                        </Flex>
                    </Td>
                    <Td> <PersonChip type={bed.personType == 1 ? 'Employee' : 'Guest'}>{bed.personType == 1 ? 'Employee' : 'Guest'}</PersonChip></Td>
                    <Td><TitleText>Bed {bed?.bed?.label} </TitleText></Td>
                    <Td><TitleText>{bed?.campName} / {bed?.blockName} / {bed?.roomName}</TitleText></Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>{formatDateForDisplay(bed.checkInTimestamp)}</TitleText>
                            <OtherText grey>{formatTimeAMPM(bed.checkInTimestamp)}</OtherText>
                        </Flex>
                    </Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>{formatDateForDisplay(bed.expectedCheckOutTimestamp)}</TitleText>
                            <OtherText grey>{formatTimeAMPM(bed.expectedCheckOutTimestamp)}</OtherText>
                        </Flex>
                    </Td>
                    <Td><TitleText>{bed?.overrideReason ? 'YES' : 'NO'}</TitleText></Td>
                </Tr>))}



            </Tbody>
        </Table>}
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(bedsHistory.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>

    </Flex >
}